import { useState, useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ChevronRight } from "lucide-react";
import { API } from "@/lib/api";

export function CMSPage() {
  const { slug } = useParams();
  const location = useLocation();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Use path as slug if not provided via params
  const pageSlug = slug || location.pathname.replace('/', '');

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios.get(`${API}/pages/${pageSlug}`)
      .then(res => setPage(res.data))
      .catch(err => {
        setError('Stránka nenalezena');
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, [pageSlug]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="w-8 h-8 animate-spin text-[#004E98]" />
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-12 text-center">
        <h1 className="text-2xl font-bold text-slate-800 mb-4">Stránka nenalezena</h1>
        <p className="text-slate-500 mb-6">Požadovaná stránka neexistuje.</p>
        <Link to="/" className="text-[#004E98] hover:underline">Zpět na úvodní stránku</Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8" data-testid="cms-page">
      {/* Breadcrumb */}
      <nav className="text-sm text-slate-500 mb-6 flex items-center gap-2">
        <Link to="/" className="hover:text-[#004E98]">Úvod</Link>
        <ChevronRight className="w-4 h-4" />
        <span className="text-slate-800">{page.title}</span>
      </nav>

      {/* Content */}
      <article className="bg-white border border-slate-200 rounded-md p-6 md:p-8">
        <div 
          className="prose prose-slate max-w-none prose-headings:text-slate-800 prose-a:text-[#004E98] prose-a:no-underline hover:prose-a:underline"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </article>
    </div>
  );
}

export default CMSPage;
